import { ClassicPreset, NodeEditor } from 'rete';
import { Node, Schemes, WorkflowState } from '../types';
import { socket } from '../workflow-editor.component';

export class StateNode extends Node {
  width = 180;
  height = 80;
  is_active = false;

  constructor(
    public state: WorkflowState,
    public editor: NodeEditor<Schemes>,
  ) {
    super(state.id);

    this.addInput('in', new ClassicPreset.Input(socket, 'in', true));
    this.addOutput('out', new ClassicPreset.Output(socket, 'out', false));
  }
}